// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageUploader-module__photoSlotWrapper__EMCHJ {
  display: flex;
  flex-direction: column;
}

.ImageUploader-module__photoSlot__obzNl {
  position: relative;
  aspect-ratio: 3 / 4;
  border-radius: var(--mantine-radius-md);
  overflow: hidden;
  cursor: pointer;
  background: linear-gradient(
    145deg,
    var(--mantine-color-gray-0) 0%,
    var(--mantine-color-gray-2) 100%
  );
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.ImageUploader-module__photoSlot__obzNl:hover {
  border-color: var(--mantine-color-dark-4);
  transform: translateY(-2px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
}

.ImageUploader-module__photoSlot__obzNl:hover .ImageUploader-module__photoSlotImage__ze2YL {
  transform: scale(1.05);
}

.ImageUploader-module__photoSlot__obzNl:hover .ImageUploader-module__photoSlotEmpty__JpIAj {
  color: var(--mantine-color-dark-5);
}

.ImageUploader-module__photoSlot__obzNl:hover .ImageUploader-module__photoSlotEmpty__JpIAj svg {
  opacity: 1;
  transform: scale(1.1);
}

.ImageUploader-module__photoSlot__obzNl:hover .ImageUploader-module__photoSlotRemove__q0_rU {
  opacity: 1;
  transform: scale(1);
}

.ImageUploader-module__dragOver__euuUb {
  border-color: var(--mantine-color-dark-5);
  background: linear-gradient(
    145deg,
    var(--mantine-color-blue-0) 0%,
    var(--mantine-color-blue-1) 100%
  );
  transform: scale(1.02);
}

.ImageUploader-module__hasPreview__GzEcL {
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06);
}

.ImageUploader-module__hasPreview__GzEcL:hover {
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04);
}

.ImageUploader-module__hasPreview__GzEcL .ImageUploader-module__photoSlotRemove__q0_rU {
  opacity: 1;
  transform: scale(1);
}

.ImageUploader-module__hasError__UguQR {
  border: 2px solid var(--mantine-color-red-6);
  background: linear-gradient(
    145deg,
    var(--mantine-color-red-0) 0%,
    var(--mantine-color-red-1) 100%
  );
}

.ImageUploader-module__hasError__UguQR .ImageUploader-module__photoSlotEmpty__JpIAj {
  color: var(--mantine-color-red-5);
}

.ImageUploader-module__photoSlotImage__ze2YL {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  transition: transform 0.25s ease;
}

.ImageUploader-module__photoSlotEmpty__JpIAj {
  position: absolute;
  inset: 0;
  color: var(--mantine-color-gray-5);
  transition: color 0.15s ease;
}

.ImageUploader-module__photoSlotEmpty__JpIAj svg {
  opacity: 0.6;
  transition: all 0.25s ease;
}

.ImageUploader-module__photoSlotOverlayText__WBAmH {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: var(--mantine-spacing-sm);
  text-align: center;
  z-index: 2;
}

.ImageUploader-module__photoSlotRemove__q0_rU {
  position: absolute;
  top: var(--mantine-spacing-xs);
  right: var(--mantine-spacing-xs);
  z-index: 10;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.15s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.ImageUploader-module__photoSlotSuccess__w6KFv {
  position: absolute;
  bottom: var(--mantine-spacing-xs);
  right: var(--mantine-spacing-xs);
  width: 28px;
  height: 28px;
  background: linear-gradient(
    135deg,
    var(--mantine-color-green-6) 0%,
    var(--mantine-color-green-7) 100%
  );
  border-radius: var(--mantine-radius-xl);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  box-shadow: 0 2px 8px color-mix(in srgb, var(--mantine-color-green-6) 40%, transparent);
  animation: ImageUploader-module__successPop___gWO3 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
`, "",{"version":3,"sources":["webpack://./src/features/application-form/ImageUploader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf;;;;GAIC;EACD,iDAAiD;EACjD,uEAAuE;AACzE;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,yEAAyE;AAC3E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC;;;;GAIC;EACD,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,wEAAwE;AAC1E;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C;;;;GAIC;AACH;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,uFAAuF;EACvF,yFAA4D;AAC9D","sourcesContent":[".photoSlotWrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.photoSlot {\n  position: relative;\n  aspect-ratio: 3 / 4;\n  border-radius: var(--mantine-radius-md);\n  overflow: hidden;\n  cursor: pointer;\n  background: linear-gradient(\n    145deg,\n    var(--mantine-color-gray-0) 0%,\n    var(--mantine-color-gray-2) 100%\n  );\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.photoSlot:hover {\n  border-color: var(--mantine-color-dark-4);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.photoSlot:hover .photoSlotImage {\n  transform: scale(1.05);\n}\n\n.photoSlot:hover .photoSlotEmpty {\n  color: var(--mantine-color-dark-5);\n}\n\n.photoSlot:hover .photoSlotEmpty svg {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.photoSlot:hover .photoSlotRemove {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.dragOver {\n  border-color: var(--mantine-color-dark-5);\n  background: linear-gradient(\n    145deg,\n    var(--mantine-color-blue-0) 0%,\n    var(--mantine-color-blue-1) 100%\n  );\n  transform: scale(1.02);\n}\n\n.hasPreview {\n  border: none;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06);\n}\n\n.hasPreview:hover {\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04);\n}\n\n.hasPreview .photoSlotRemove {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.hasError {\n  border: 2px solid var(--mantine-color-red-6);\n  background: linear-gradient(\n    145deg,\n    var(--mantine-color-red-0) 0%,\n    var(--mantine-color-red-1) 100%\n  );\n}\n\n.hasError .photoSlotEmpty {\n  color: var(--mantine-color-red-5);\n}\n\n.photoSlotImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  transition: transform 0.25s ease;\n}\n\n.photoSlotEmpty {\n  position: absolute;\n  inset: 0;\n  color: var(--mantine-color-gray-5);\n  transition: color 0.15s ease;\n}\n\n.photoSlotEmpty svg {\n  opacity: 0.6;\n  transition: all 0.25s ease;\n}\n\n.photoSlotOverlayText {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: var(--mantine-spacing-sm);\n  text-align: center;\n  z-index: 2;\n}\n\n.photoSlotRemove {\n  position: absolute;\n  top: var(--mantine-spacing-xs);\n  right: var(--mantine-spacing-xs);\n  z-index: 10;\n  opacity: 0;\n  transform: scale(0.8);\n  transition: all 0.15s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.photoSlotSuccess {\n  position: absolute;\n  bottom: var(--mantine-spacing-xs);\n  right: var(--mantine-spacing-xs);\n  width: 28px;\n  height: 28px;\n  background: linear-gradient(\n    135deg,\n    var(--mantine-color-green-6) 0%,\n    var(--mantine-color-green-7) 100%\n  );\n  border-radius: var(--mantine-radius-xl);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n  box-shadow: 0 2px 8px color-mix(in srgb, var(--mantine-color-green-6) 40%, transparent);\n  animation: successPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"photoSlotWrapper": `ImageUploader-module__photoSlotWrapper__EMCHJ`,
	"photoSlot": `ImageUploader-module__photoSlot__obzNl`,
	"photoSlotImage": `ImageUploader-module__photoSlotImage__ze2YL`,
	"photoSlotEmpty": `ImageUploader-module__photoSlotEmpty__JpIAj`,
	"photoSlotRemove": `ImageUploader-module__photoSlotRemove__q0_rU`,
	"dragOver": `ImageUploader-module__dragOver__euuUb`,
	"hasPreview": `ImageUploader-module__hasPreview__GzEcL`,
	"hasError": `ImageUploader-module__hasError__UguQR`,
	"photoSlotOverlayText": `ImageUploader-module__photoSlotOverlayText__WBAmH`,
	"photoSlotSuccess": `ImageUploader-module__photoSlotSuccess__w6KFv`,
	"successPop": `ImageUploader-module__successPop___gWO3`
};
module.exports = ___CSS_LOADER_EXPORT___;
